import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
  ReactiveFormsModule,
  FormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { IGrupoArt } from '../../../../../@interfaces/grupoart.interface';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { InventoryService } from '../../../../../@pages/inventory/inventory.service';
import Swal from 'sweetalert2';
import { IPresentationTypes } from 'src/app/@interfaces/presentationTypes';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';

import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-crud-groups',
  templateUrl: './crud-groups.component.html',
  styleUrls: ['./crud-groups.component.css'],
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    TranslatePipe,
  ],
})
export class CrudGroupsComponent implements OnInit, OnDestroy {
  registerForm: UntypedFormGroup = this.fb.group({
    group: ['', [Validators.required]],
    presentation: ['', [Validators.required]],
  });

  @Input() listGroups: Array<IGrupoArt> = [];
  listPresentations: Array<IPresentationTypes> = [];
  unsubscribe$ = new Subject<void>();
  constructor(
    private fb: UntypedFormBuilder,
    private inventory: InventoryService,
    private router: Router,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.inventory
      .listGrupoArt()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.listGroups = result;
      });
    this.inventory
      .getPresentations()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        this.listPresentations = result;
      });
  }

  remove(id: number, index: number) {
    Swal.fire({
      title: this.translate.instant('Are you sure?'),
      text: this.translate.instant('You won not be able to revert this!'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff5400',
      cancelButtonColor: 'rgb(0, 0, 0)',
      confirmButtonText: 'Confirm',
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        this.inventory
          .removeGroup(id)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((result) => {
            if (!result) {
              Swal.fire(
                'Error',
                this.translate.instant('Something was wrong'),
                'error',
              );
            } else {
              Swal.fire(
                this.translate.instant('Good'),
                this.translate.instant('Group removed'),
                'success',
              ).then((data) => {
                if (data.isConfirmed) {
                  this.router
                    .navigateByUrl('/dialog', { skipLocationChange: true })
                    .then(() => {
                      this.router.navigate(['/inventory']);
                    });
                  this.inventory
                    .listGrupoArt()
                    .pipe(takeUntil(this.unsubscribe$))
                    .subscribe((result) => {
                      this.listGroups = result;
                    });
                }
              });
            }
          });
      }
    });
  }

  update() {
    if (this.registerForm.invalid === true) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: this.translate.instant('Group Invalid, Please Check!'),
      });
      return;
    }
    this.inventory
      .createGroup(
        this.registerForm.get('group')?.value,
        parseInt(this.registerForm.get('presentation')?.value),
      )
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result) {
          Swal.fire({
            title: this.translate.instant('Created'),
            text: this.translate.instant('Group created successfully!'),
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#f44336',
            confirmButtonText: 'Ok',
          }).then((data) => {
            if (data.isConfirmed) {
              this.router
                .navigateByUrl('/dialog', { skipLocationChange: true })
                .then(() => {
                  this.router.navigate(['/inventory']);
                });
              this.inventory
                .listGrupoArt()
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe((result) => {
                  this.listGroups = result;
                });
            }
          });
        } else {
          Swal.fire(
            this.translate.instant('Something was wrong'),
            this.translate.instant('Failed'),
            'error',
          );
        }
      });
  }

  textValid(text: string, index?: number) {
    return (
      this.registerForm.get(text)?.invalid &&
      this.registerForm.get(text)?.touched
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
